export default __webpack_public_path__ + "static/media/money.4b02dbc3.svg";